<template>
    <div>
        <div v-if="state === 1" v-loading="state === 1" style="min-height:150px;">&nbsp;</div>
        <div v-else-if="!total && state > 1">No Activities found.</div>
        <div v-else>
            <div v-for="(obj, index) in groups" :key="index" class="timed-activity">
                <div class="ta-date">
                    <span>{{ obj.date }}</span>
                </div>
                <div class="ta-record-w">
                    <div v-for="log in obj.logs" :key="log.id" class="ta-record">
                        <div class="ta-timestamp">
                            <strong>{{ log.time }}</strong> {{ log.timeType }}
                        </div>
                        <div class="ta-activity">
                            <v-runtime-template :template="peer.common.formatActivityMsg(log, isList)"></v-runtime-template>
                        </div>
                    </div>
                </div>
            </div>
            <infinite-loading @infinite="infiniteHandler" spinner="waveDots" :forceUseInfiniteWrapper="scrollNode" :distance="isList ?80 :40">
                <div slot="no-more" style="margin-top:25px;color:#9b9898;">--- No more activity logs found ---</div>
                <div slot="no-results" style="margin-top:25px;color:#9b9898;">--- No more activity logs found ---</div>
            </infinite-loading>
        </div>
    </div>
</template>

<script>
import datetime from '@/mixins/datetime'

export default {
    props: {
        state: { // 1-initial load, 2-initial loaded, 3-loading more, 4-more loaded
            type: Number
        },
        scrollNode: {
            type: String
        },
        path: {
            type: String
        },
        query: {
            type: Object,
            default: () => {
                return {}
            }
        },
        isList: {
            type: Boolean,
            default: false
        }
    },
    
    mixins: [datetime],
    
    data() {
        return {
            total: 0,
            noOldLogs: false,
            groups: {}
        }
    },
    
    watch: {
        path() {
            this.fetchActivityLogs(1)
        }
    },
    
    mounted() {
        this.fetchActivityLogs(1)
    },
    
    methods: {
        fetchActivityLogs(state, alwaysCallback) {
            this.$emit('update:state', state)
            
            this.peer.common.getActivityLogs(this.path, this.query, state === 1, this.isList).done((d) => {
                this.total = 0
                this.noOldLogs = d.noOldLogs
                this.groups = {}
                
                this.peer.$.each(d.logs, (index, v) => {
                    let t = this.convertAndDisplay(v.timeStamp, 'Ymd@d M Y@h:i@a').split('@')
                    let k = 'K'+t[0]
                    
                    if(!this.groups[k]) {
                        this.groups[k] = {
                            date: t[1],
                            logs: []
                        }
                    }
                    
                    v.time = t[2]
                    v.timeType = t[3]
                    
                    this.groups[k].logs.push(v)
                    this.total++
                })
            }).fail((err) => {
                this.peer.misc.notify('E', err)
            }).always(() => {
                window.setTimeout(() => {
                    this.$emit('update:state', this.state+1)
                    
                    if(alwaysCallback)
                        alwaysCallback()
                }, 300)
            })
        },
        
        infiniteHandler($state) {
            if(this.noOldLogs)
                $state.complete()
            else {
                this.fetchActivityLogs(3, () => {
                    if(this.noOldLogs)
                        $state.complete()
                    else
                        $state.loaded()
                })
            }
        }
    }
}
</script>
